<template>
  <div>
    <el-form-item label="样式：" label-width="110px">
      <el-radio-group
        v-model="config['style_type']"
        @change="change"
        class="radio-group"
      >
        <el-col
          v-for="(item, index) in radioList"
          :key="index"
          class="radio-item"
        >
          <el-radio :label="item.value"
            ><img :src="item.url" alt="" class="radio-img"
          /></el-radio>
          <span
            v-if="item.text"
            :class="index === currentRadioIndex - 1 ? 'selected' : ''"
            >{{ item.text }}</span
          >
        </el-col>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="field.name + '：'" label-width="110px">
      <draggable v-model="config[field.key]">
        <el-row
          class="image-item"
          v-for="(item, index) in config[field.key]"
          :key="index"
          type="flex"
        >
          <i class="el-icon-remove-outline" @click="removeItem(index)"></i>

          <el-col class="col-left">
            <choose-photo
              :config="config"
              :field="field"
              :quote="0"
              :imgName="'imgUrl'"
              :index="index"
            ></choose-photo>
          </el-col>
          <el-col class="col-right">
            <div class="link-name" v-if="config[field.key][index]['link_name']">
              {{ config[field.key][index]["link_name"] }}：{{
                config[field.key][index]["link_data"]
              }}
            </div>
            <div class="ItemBackground">
              <span>背景颜色：</span>
              <el-color-picker
                v-model="config[field.key][index]['background_color']"
              ></el-color-picker>
            </div>
            <div class="Sub_Title_Background">
              <span>副标题背景：</span>
              <el-color-picker
                v-model="config[field.key][index]['sub_title_background']"
              ></el-color-picker>
            </div>
            <div class="Sub_Title_Background">
              <span>主标题颜色：</span>
              <el-color-picker
                v-model="config[field.key][index]['main_title_color']"
              ></el-color-picker>
            </div>
            <div class="Sub_Title_Background">
              <span>副标题颜色：</span>
              <el-color-picker
                v-model="config[field.key][index]['sub_title_color']"
              ></el-color-picker>
            </div>
            <div class="MainTitle">
              <span>主标题</span>
              <el-input
                type="text"
                placeholder="请输入"
                v-model="config[field.key][index]['main_title']"
              />
            </div>
            <div class="SubTitle">
              <span>副标题</span
              ><el-input
                type="text"
                placeholder="请输入"
                v-model="config[field.key][index]['sub_title']"
              />
            </div>
            <el-button
              size="mini"
              @click="openDialog(index)"
              v-text="
                config[field.key][index]['link_name']
                  ? '更换链接'
                  : '请选择链接'
              "
              style="margin-right: 10px"
            ></el-button>
            <el-button
              v-if="config[field.key][index]['link_name']"
              size="mini"
              class="clear-link"
              @click="clearLink(index)"
              style="margin-left: 0px"
              >清除链接
            </el-button>
          </el-col>
          <i
            class="el-icon-circle-close-outline"
            @click="removeImageItem(index)"
          ></i>
        </el-row>
      </draggable>
      <el-button size="mini" @click="addImageItem()">添加导航</el-button>
    </el-form-item>
    <!-- 店铺地址对话框 -->
    <el-dialog
      title="请选择链接"
      :visible.sync="dialog.visible"
      @close="closeDialog"
    >
      <helper @select="select" @close="closeDialog"></helper>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ChoosePhoto from "./choose-photo.vue";

export default {
  name: "tms-type-swiper-nav",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkNameList: {},
      currentIndex: 0,
      currentRadioIndex: 1,

      radioList: [
        {
          url: "https://mktv-in-cdn.mockuai.com/16397197504888939.png",
          value: 1,
          text: "样式一",
        },
        {
          url: "https://mktv-in-cdn.mockuai.com/16397197504855294.png",
          value: 2,
          text: "样式二",
        },
      ],
    };
  },

  components: {
    ChoosePhoto,
    draggable,
  },

  mounted() {},

  methods: {
    clearLink(index) {
      delete this.config[this.field.key][index].link_name;
      delete this.config[this.field.key][index].link_data;
      delete this.config[this.field.key][index].link_type;
      let temp = this.config[this.field.key][index];
      this.config[this.field.key].splice(index, 1, temp);
    },
    addImageItem() {
      if (this.config[this.field.key].length < 12) {
        this.config[this.field.key].push({
          main_title: "主标题",
          sub_title: "副标题",
          background_color: "#ff6600",
          sub_title_background: "#F19CD9",
          sub_title_color: "",
          imgUrl: "",
          main_title_color: "",
        });
      }
    },
    removeItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    removeImageItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], "imgUrl", src);
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(link, linkName, linkType) {
      this.config[this.field.key][this.currentIndex].link_name = linkName;
      this.config[this.field.key][this.currentIndex].link_data = link;
      this.config[this.field.key][this.currentIndex].link_type = linkType;
      this.dialog.visible = false;
    },
    change(val) {
      this.currentRadioIndex = val;
      this.config.type = val;
    },
  },
};
</script>



<style lang="scss" scoped>
.image-item {
  position: relative;
  border: 1px solid #e3e7ee;
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  .col-left {
    flex: 0 0 150px;
  }
  .col-right {
    flex: 1;
    .link-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100px;
      padding-right: 10px;
    }
  }
  .el-icon-circle-close-outline {
    font-size: 18px;
    position: absolute;
    top: -9px;
    right: -9px;
    background: #fff;
    cursor: pointer;
  }
  .el-icon-remove-outline {
    font-size: 22px;
    position: absolute;
    top: -10px;
    left: -10px;
    background: #fff;
    cursor: pointer;
  }
  .ItemBackground,
  .Sub_Title_Background {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .MainTitle,
  .SubTitle {
    box-sizing: border-box;
    display: flex;
    margin-bottom: 10px;
    span {
      width: 100px;
      display: block;
    }
  }
}
.radio-group {
  display: flex;
  flex-wrap: wrap;
  .radio-item {
    width: 110px;
    margin-bottom: 10px;
    img {
      border: 1px solid #e3e7ee;
    }
    [aria-checked="true"] img {
      border: 1px solid #4a8ef7;
    }
    span {
      display: block;
      font-size: 13px;
      padding: 10px 0 10px 0;
      margin: 0 8px 0 24px;
      text-align: center;
    }
    span.selected {
      color: #4a8ef7;
    }
  }
}
.radio-img {
  width: 80px;
  border-radius: 7px;
}
</style>
